export default "__VITE_ASSET__8UsCgRdB__"